'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var _require2 = require('interface-datastore'),
    Adapter = _require2.Adapter,
    Key = _require2.Key;

var sh = require('./shard');

var KeytransformStore = require('./keytransform');

var shardKey = new Key(sh.SHARDING_FN);
var shardReadmeKey = new Key(sh.README_FN);
/**
 * Backend independent abstraction of go-ds-flatfs.
 *
 * Wraps another datastore such that all values are stored
 * sharded according to the given sharding function.
 */

var ShardingDatastore = /*#__PURE__*/function (_Adapter) {
  _inherits(ShardingDatastore, _Adapter);

  var _super = _createSuper(ShardingDatastore);

  function ShardingDatastore(store, shard) {
    var _this;

    _classCallCheck(this, ShardingDatastore);

    _this = _super.call(this);
    _this.child = new KeytransformStore(store, {
      convert: _this._convertKey.bind(_assertThisInitialized(_this)),
      invert: _this._invertKey.bind(_assertThisInitialized(_this))
    });
    _this.shard = shard;
    return _this;
  }

  _createClass(ShardingDatastore, [{
    key: "open",
    value: function open() {
      return this.child.open();
    }
  }, {
    key: "_convertKey",
    value: function _convertKey(key) {
      var s = key.toString();

      if (s === shardKey.toString() || s === shardReadmeKey.toString()) {
        return key;
      }

      var parent = new Key(this.shard.fun(s));
      return parent.child(key);
    }
  }, {
    key: "_invertKey",
    value: function _invertKey(key) {
      var s = key.toString();

      if (s === shardKey.toString() || s === shardReadmeKey.toString()) {
        return key;
      }

      return Key.withNamespaces(key.list().slice(1));
    }
  }, {
    key: "put",
    value: function put(key, val, options) {
      return this.child.put(key, val, options);
    }
  }, {
    key: "get",
    value: function get(key, options) {
      return this.child.get(key, options);
    }
  }, {
    key: "has",
    value: function has(key, options) {
      return this.child.has(key, options);
    }
  }, {
    key: "delete",
    value: function _delete(key, options) {
      return this.child.delete(key, options);
    }
  }, {
    key: "batch",
    value: function batch() {
      return this.child.batch();
    }
  }, {
    key: "query",
    value: function query(q, options) {
      var _this2 = this;

      var tq = {
        keysOnly: q.keysOnly,
        offset: q.offset,
        limit: q.limit,
        filters: [function (e) {
          return e.key.toString() !== shardKey.toString();
        }, function (e) {
          return e.key.toString() !== shardReadmeKey.toString();
        }]
      };

      if (q.prefix != null) {
        tq.filters.push(function (e) {
          return _this2._invertKey(e.key).toString().startsWith(q.prefix);
        });
      }

      if (q.filters != null) {
        var filters = q.filters.map(function (f) {
          return function (e) {
            return f(Object.assign({}, e, {
              key: _this2._invertKey(e.key)
            }));
          };
        });
        tq.filters = tq.filters.concat(filters);
      }

      if (q.orders != null) {
        tq.orders = q.orders.map(function (o) {
          return /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
              var ordered;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      res.forEach(function (e) {
                        e.key = _this2._invertKey(e.key);
                      });
                      _context.next = 3;
                      return o(res);

                    case 3:
                      ordered = _context.sent;
                      ordered.forEach(function (e) {
                        e.key = _this2._convertKey(e.key);
                      });
                      return _context.abrupt("return", ordered);

                    case 6:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }();
        });
      }

      return this.child.query(tq, options);
    }
  }, {
    key: "close",
    value: function close() {
      return this.child.close();
    }
  }], [{
    key: "createOrOpen",
    value: function () {
      var _createOrOpen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(store, shard) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return ShardingDatastore.create(store, shard);

              case 3:
                _context2.next = 9;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);

                if (!(_context2.t0 && _context2.t0.message !== 'datastore exists')) {
                  _context2.next = 9;
                  break;
                }

                throw _context2.t0;

              case 9:
                return _context2.abrupt("return", ShardingDatastore.open(store));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 5]]);
      }));

      function createOrOpen(_x2, _x3) {
        return _createOrOpen.apply(this, arguments);
      }

      return createOrOpen;
    }()
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(store) {
        var shard;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return sh.readShardFun('/', store);

              case 2:
                shard = _context3.sent;
                return _context3.abrupt("return", new ShardingDatastore(store, shard));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function open(_x4) {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(store, shard) {
        var exists, put, diskShard, a, b;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return store.has(shardKey);

              case 2:
                exists = _context4.sent;

                if (exists) {
                  _context4.next = 6;
                  break;
                }

                put = typeof store.putRaw === 'function' ? store.putRaw.bind(store) : store.put.bind(store);
                return _context4.abrupt("return", Promise.all([put(shardKey, Buffer.from(shard.toString() + '\n')), put(shardReadmeKey, Buffer.from(sh.readme))]));

              case 6:
                _context4.next = 8;
                return sh.readShardFun('/', store);

              case 8:
                diskShard = _context4.sent;
                a = (diskShard || '').toString();
                b = shard.toString();

                if (!(a !== b)) {
                  _context4.next = 13;
                  break;
                }

                throw new Error("specified fun ".concat(b, " does not match repo shard fun ").concat(a));

              case 13:
                throw new Error('datastore exists');

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function create(_x5, _x6) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return ShardingDatastore;
}(Adapter);

module.exports = ShardingDatastore;